import React, { Component } from "react";
import Api from "../Api";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import { Link } from "react-router-dom";
import moment from "moment";
UIkit.use(Icons);

export default class ConsultAppointmentToday extends Component {
  state = {
    list: [],
    group: "self",
    loadingApi: false,
  };

  memberById = {};

  consultById = {};

  listGet = async () => {
    this.setState({ loadingApi: true });

    var { list, consult, member } = await Api.consult("AppointmentList", {
      dateStart: moment().startOf("d").format("YYYY-MM-DD 00:00:00"),
      dateStop: moment().endOf("d").format("YYYY-MM-DD HH:mm:ss"),
      group: this.state.group,
    });
    

    if (!list) list = [];
    if (!member) member = [];
    if (!consult) consult = [];

    member.forEach((data) => {
      this.memberById[data.id] = data;
    });

    consult.forEach((data) => {
      this.consultById[data.id] = data;
    });

    this.setState({
      list,
      loadingApi: false,
    });
  };
  
  logVideoCallSend = async (consultId, memberId, campaignId) => {
    Api.member("LogVideoCallAdd", {
      consultId,
      memberId,
      campaignId,
      chatBy: 'consult'
    }); 
  };

  
  // firebaseListenUpdate = (chatby) => {
  //   firebase.database().ref(`chatlist_consult/` + this.props[this.props.chatby === 'c' ?  'consult' : 'member'].id).on('value', (snapshot) => {

  //     console.log("UPDATE!")

  //     setTimeout(() => {
  //       this.chatListGet(true);
  //       this.messageListGet(true);
  //     }, 500);
  //   });
  // }
  
  // firebaseChatlistUpdate = () => {
  //   firebase.database().ref(`chatlist_c/${this.state.messageConsultId}`).set(+new Date);

  //   firebase.database().ref(`chatlist_m/${this.state.messageMemberId}`).set(+new Date);
  // }

  componentDidMount() {
    this.listGet();
  }

  render() {
    return (
      <div className="uk-card uk-card-default uk-padding-small">
        <div className="d-card-header">
          <div className="d-card-header-left">นัดหมายวันนี้</div>
          <div className="d-card-header-right">
            <Link className="uk-link-reset uk-text-small" to={"/consult/appointmentList"}>ดูตารางทั้งหมด</Link>
          </div>
        </div>
        <div>
          <table className="uk-table uk-table-small uk-table-divider">
            <thead>
              <tr>
                <th>ที่</th>
                <th>วันที่</th>
                <th>เวลา</th>
                <th>ชื่อคนไข้</th>
                <th>ผู้นัดหมาย</th>
                <th>นัดหมายเพื่อ</th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingApi === true ? (
                <tr>
                  <td colSpan="100%">
                    <div className="uk-padding-small uk-text-center">
                      <span uk-spinner=""></span>
                    </div>
                  </td>
                </tr>
              ) : this.state.list.length === 0 ? (
                <tr>
                  <td colSpan="100%">
                    <div className="uk-padding-small uk-text-center">
                      ไม่พบข้อมูล
                    </div>
                  </td>
                </tr>
              ) : (
                this.state.list.map((data, key) => {

                  var _member = this.memberById[data.memberid];

                  if (_member) {
                    _member = `${_member.nameprefix} ${_member.name} ${_member.lastname}`;
                  } else {
                    _member = "-";
                  }

                  var _consult = this.consultById[data.consultid];
                  if (_consult) {
                    _consult = `${_consult.nameprefix} ${_consult.name} ${_consult.lastname}`;
                  } else {
                    _consult = "-";
                  }

                  return (
                    <tr key={`row${data.id}`}>
                      <td>{key + 1}</td>
                      <td>{moment(data.dateadd).format("DD/MM/YYYY")}</td>
                      <td>{moment(data.dateadd).format("HH:mm น.")}</td>
                      <td>{_member}</td>
                      <td>{_consult}</td>
                      <td className="uk-text-center">
                        <div>{data.name}</div>
                        <div>
                        <a
                          href={`https://con.defence-innovation.com/${data.memberid}/${data.consultid}?openExternalBrowser=1`}
                          className="uk-margin-right"
                          target="_blank"
                          onClick={()=>{
                            this.logVideoCallSend(data.consultid, data.memberid, data.campaignid)
                          }}
                        >
                          กดวีดีโอคอล
                        </a>
                        <a
                          href={`/consult/chat?messageSelectIndex=ca${data.campaignid}_co${data.consultid}_m${data.memberid}`}
                        >
                          กดไปแชท
                        </a>

                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
